module.exports = __webpack_public_path__ + "static/media/homepage_metatag_image.d06a8627.jpeg";